import { BaseEntity } from 'src/app/entity/base-entity';
import { ContactDto } from 'src/app/entity/contactDto';

export class ManufacturerRequestDto {
  customerId: number;
  manufId: string;
  status: number;
}
